import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const ARTISTS = [
  {
    name: "SKY WOODS",
    role: "THE BREAKOUT WIN",
    note: "Ranked across 10+ global genre charts. The big one — proof the system works at scale.",
    img: "/assets/sky-woods.png",
    featured: true,
    id: "sky-woods",
  },
  {
    name: "ONCORE",
    role: "FOUNDER // ARTIST",
    note: "The outlaw creator behind the seal.",
    img: "/assets/oncore.png",
    id: "oncore",
  },
  {
    name: "FLOYD WEST22",
    role: "ROSTER",
    note: "'On Repeat' — Spotify Tech House 2024 playlist, position 6. São Paulo to the world.",
    img: "/assets/floyd-west22-v2.jpg",
    id: "floyd-west22",
  },
  {
    name: "6LU_U",
    role: "ROSTER",
    note: "'No Hope For Me Without You' — #5 iTunes Germany Christian & Gospel.",
    img: "/assets/6luu.jpg",
    id: "6lu-u",
  },
  {
    name: "QUAN FLEES",
    role: "ROSTER",
    note: "RISE — New York Fashion Week showcase.",
    img: "/assets/quan-flees.jpg",
    id: "quan-flees",
  },
];

const Card = ({ artist, index }) => (
  <motion.article
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay: index * 0.08, ease: [0.16, 1, 0.3, 1] }}
    className={`group relative overflow-hidden border border-[#22222B] bg-[#0C0C10] ${
      artist.featured ? "sm:col-span-2 aspect-[16/9] sm:aspect-[21/10]" : "aspect-[4/5]"
    }`}
    data-testid={`artist-card-${artist.id}`}
  >
    <img
      src={artist.img}
      alt={artist.name}
      loading="lazy"
      className="absolute inset-0 h-full w-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700 ease-out"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-[#08080A] via-[#08080A]/30 to-transparent" />
    <div className="absolute inset-x-0 bottom-0 p-6 sm:p-8">
      <p className="mono text-[10px] tracking-[0.3em] text-[#00F0FF] mb-2">{artist.role}</p>
      <div className="flex items-end justify-between gap-4">
        <h3 className="font-display uppercase text-3xl sm:text-4xl text-[#F2F2F5] leading-none">{artist.name}</h3>
        <ArrowUpRight className="h-6 w-6 text-[#CCFF00] opacity-0 group-hover:opacity-100 transition-opacity duration-500 shrink-0" />
      </div>
      <p className="mono text-[10px] tracking-[0.15em] text-[#A0A0AB] mt-3 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
        {artist.note.toUpperCase()}
      </p>
    </div>
    <span className="absolute top-0 left-0 h-[2px] w-0 bg-[#CCFF00] transition-all duration-700 group-hover:w-full" />
  </motion.article>
);

export default function Roster() {
  return (
    <section id="roster" className="relative py-28 sm:py-36" data-testid="roster-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mb-16"
        >
          <p className="mono text-[11px] tracking-[0.35em] text-[#00F0FF] mb-4" data-testid="roster-eyebrow">
            THE ROSTER // CASE FILES
          </p>
          <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95]" data-testid="roster-heading">
            TALENT WE <span className="text-stroke-faint">TURNED</span> INTO BRANDS
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {ARTISTS.map((a, i) => (
            <Card key={a.id} artist={a} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
